import { z } from 'zod/mini'

import { cartItemSchema } from './cart-item'
import { gtmMetadataShape } from './gtm-metadata'
import { nonEmptyString } from './non-empty-string'
import { tradeInDetailsSchema } from './trade-in-details'

export const viewCartSchema = z.strictObject({
  ...gtmMetadataShape,
  event: z.literal('view_cart'),
  has_trade_in: z.boolean(),
  // An empty cart is a valid state of the cart page: no minimum on items/value.
  ecommerce: z.strictObject({
    currency: nonEmptyString(),
    value: z.number().check(z.gte(0)),
    items: z.array(cartItemSchema),
  }),
  trade_in_details: z.optional(tradeInDetailsSchema),
})
